
(function () {
  if (window.__cxAccordionAnim) return;
  window.__cxAccordionAnim = true;

  var DUR = 350; // ms — keep in sync with the CSS transition
  var EASE = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

  function bind(details) {
    if (details.__cxBound) return;
    var summary = details.querySelector(':scope > summary');
    var content = summary && summary.nextElementSibling;
    if (!content || !content.classList || !content.classList.contains('accordion__content')) return;
    details.__cxBound = true;
    content.style.overflow = 'hidden';
    content.style.transition = 'height ' + DUR + 'ms ' + EASE;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (content.__cxAnim) return;
      content.__cxAnim = true;

      if (details.open) {
        // CLOSE: current height -> 0
        content.style.height = content.scrollHeight + 'px';
        void content.offsetHeight; // force reflow so the next change transitions
        content.style.height = '0px';
        window.setTimeout(function () {
          details.open = false;
          content.style.height = '';
          content.__cxAnim = false;
        }, DUR);
      } else {
        // OPEN: 0 -> content height, then release to auto
        details.open = true;
        content.style.height = '0px';
        void content.offsetHeight; // force reflow
        content.style.height = content.scrollHeight + 'px';
        window.setTimeout(function () {
          content.style.height = 'auto';
          content.__cxAnim = false;
        }, DUR);
      }
    });
  }

  function init() {
    document.querySelectorAll('details').forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init); // theme editor re-render
})();
